<template lang="pug">
    section.homepage
        intro(v-if="loading")
        navbar
        section.section.header-image.is-relative.is-fullview.is-parallax
            div.is-vmiddle
                div.container.has-text-white.has-text-centered.animated.fadeInUp.slow
                    h1.is-size-2.is-uppercase.has-text-weight-light.has-line-height(v-html="$t('page_02.section_1.title')")
                    h2.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_02.section_1.subtitle') }}
        //- familia
        section.section.section-2.is-medium.has-background-white-ter
            div.container
                div.has-text-centered
                    h2.is-size-7.is-uppercase.has-letter-spacing  {{ $t('page_02.section_2.subtitle') }}
                    h1.is-size-1.is-uppercase.line-height-less {{ $t('page_02.section_2.title') }}
                    div.spaner.has-background-blue
                div.columns.is-centered
                    div.column.has-text-justified.has-text-centered-mobile
                        p {{ $t('page_02.section_2.text_1') }}
                    div.column.has-text-justified.has-text-centered-mobile
                        p {{ $t('page_02.section_2.text_2') }}
                div.columns.is-centered.is-mobile
                    div.column.is-3-desktop.is-8-mobile.has-text-centered-mobile
                        img(src="../assets/images/2_Home/elementos/alexandre_assinatura-01.svg")

        //- vinhos
        section.section.section-3
            div.container.has-text-blue.has-background-white.has-text-centered
                h1.is-size-1.is-uppercase(data-aos="fade-up" data-aos-id="wat") {{ $t('page_02.section_3.title') }}
            wine-list(:wines="wines")
            div.has-background-white-ter.has-text-centered.button-all-wines
                router-link.button.is-small.is-full-blue(:to="$t('page_02.section_3.button.url') + '/' + defaultBrand") {{ $t('page_02.section_3.button.text') }}

        //- terroir
        section.section.section-4.is-relative
            div.section-content
                div.container
                    div.columns.is-centered
                        div.column.is-10.has-text-blue.has-text-centered
                            h2.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_02.section_4.subtitle') }}
                            h1.is-size-1.is-uppercase.line-height-less {{ $t('page_02.section_4.title') }}
                            p(v-html="$t('page_02.section_4.text_1')")
                            router-link.button.is-small.is-outlined-blue(:to="$t('page_02.section_4.button.url')") {{ $t('page_02.section_4.button.text') }}

        //- enoturismo
        section.section.section-5.is-relative
            div.section-content
                div.container
                    div.columns.is-centered
                        div.column.is-10.has-text-centered.has-text-white
                            h2.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_02.section_5.subtitle') }}
                            h1.is-size-1.is-uppercase.line-height-less {{ $t('page_02.section_5.title') }}
                            p(v-html="$t('page_02.section_5.text_1')")
                            router-link.button.is-small.is-outlined-white(:to="$t('page_02.section_5.button.url')") {{ $t('page_02.section_5.button.text') }}

        //- sustentabilidade
        section.section.section-6.is-relative
            div.section-content
                div.container
                    div.columns.is-centered
                        div.column.is-10.has-text-white.has-text-centered
                            h2.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_02.section_6.subtitle') }}
                            h1.is-size-1.is-uppercase.line-height-less {{ $t('page_02.section_6.title') }}
                            p(v-html="$t('page_02.section_6.text_1')")
                            router-link.button.is-small.is-outlined-white(:to="$t('page_02.section_6.button.url')") {{ $t('page_02.section_6.button.text') }}

        //- noticias
        section.section.section-7.is-relative
            div.section-content
                div.container.has-text-white.has-text-centered
                    h1.is-size-1.is-uppercase.line-height-less {{ $t('page_02.section_7.title') }}
                    router-link.button.is-small.is-outlined-white(:to="$t('page_02.section_7.button.url')") {{ $t('page_02.section_7.button.text') }}
        the-footer

        template(v-if="wine")
            wine-features(:w="wine", @close="wine = null", @change-wine="changeWine")

</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'
import Intro from '@/components/the-intro'

import WineList from '@/components/wine-list'
import WineFeatures from '@/components/wine-features'

export default {
    name: 'homepage',
    components: { Navbar, TheFooter, Intro, WineList, WineFeatures },
    data () {
        return {
            loading: true,
            wines: [],
            defaultBrand: 3,
            wine: null
        }
    },
    created () {
        document.body.style.overflowY = 'hidden'
        this.createEvents()
        this.fetch()
        setTimeout(this.hideIntro, 2250)
    },
    methods: {
        createEvents () {
            this.$bus.$on('open-wine', this.openWine)
        },

        hideIntro () {
            this.loading = false
            document.body.style.overflowY = 'auto'
        },

        async fetch () {
            try {
                const wines = await this.$api.getWines({ brand_id: this.defaultBrand })
                this.wines = wines.filter(w => +w.sort !== 0).sort((a, b) => (+a.sort > +b.sort) ? 1 : -1)
            } catch (error) {
                console.log(error)
            }
        },

        changeWine (v) {
            const idx = this.wines.findIndex(i => i.id === this.wine.id)
            this.wine = this.wines[idx + v] || this.wine
        },

        openWine (w) {
            this.wine = w
        }
    }
}
</script>

<style lang="stylus" scoped>

.on-bottom
    position absolute
    width 100%
    bottom 50px
    left: 0

    display flex
    align-items center

.line-height-less
    line-height 1

.container
    h1, p, .spaner
        margin-bottom 35px
    h2
        margin-bottom 0.5rem

    @media screen and (max-width: 768px)
        padding 50px 10px

.spaner
    margin 0 auto
    width 1px
    height 40px

.header-image
    background-image url("../assets/images/2_Home/banner_header_1920x1080.jpg")
    -webkit-background-size cover
    background-size cover

    @media screen and (max-width 768px)
        height 100vh

.section-2
    @media screen and (min-width 1024px)
        .columns .column
            max-width 350px

.section-3
    padding-top 120px

    @media screen and (max-width 768px)
        .container
            padding 0

    div:nth-child(3)
        padding-bottom 120px

.button-all-wines
    padding-top 30px

.section-content
    height calc(100vw / 2.13)

    display flex
    align-items center

    background-position center
    background-size cover

    @media screen and (max-width 768px)
        height 100vh

.section-4 .section-content
    background-image url("../assets/images/2_Home/bg-terroirs.jpg")

    @media screen and (max-width: 768px)
        background-image url("../assets/images/2_Home/HomePage_terroir-mobile.jpg")

.section-5 .section-content
    background-image url("../assets/images/2_Home/bg-enoturismo.jpg")

    @media screen and (max-width: 768px)
        background-image url("../assets/images/2_Home/HomePage_enoturismo-mobile.jpg")

.section-6 .section-content
    background-image url("../assets/images/2_Home/bg-sustentabilidade.jpg")

    @media screen and (max-width: 768px)
        background-image url("../assets/images/2_Home/HomePage_sustentabilidade-mobile.jpg")

.section-7 .section-content
    background-image url("../assets/images/2_Home/bg-noticias.jpg")

    @media screen and (max-width: 768px)
        background-image url("../assets/images/2_Home/HomePage_noticias-mobile.jpg")

</style>
